import { render, staticRenderFns } from "./ambassadorEdit.vue?vue&type=template&id=58b86c28&scoped=true"
import script from "./ambassadorEdit.vue?vue&type=script&lang=js"
export * from "./ambassadorEdit.vue?vue&type=script&lang=js"
import style0 from "./ambassadorEdit.vue?vue&type=style&index=0&id=58b86c28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b86c28",
  null
  
)

export default component.exports